/*
 * Rekenaar voor de relatiegeschenken-pagina.
 *
 * Dit bestand bevat met opzet GEEN zichtbare tekst. Elk label komt uit de JSON-blob
 * die de sectie meerendert (script[data-rg-tekst]), want alleen section settings zijn
 * door Shopify te vertalen. Een string die hier zou staan blijft in alle vijf de talen
 * Nederlands. De enige taak van dit bestand is rekenen, formatteren en de samenvatting
 * voor het offerteformulier opbouwen.
 *
 * Rekenvolgorde: prijs per pakket is de som van de gekozen opties. Het totaal is prijs
 * per pakket maal het aantal, en daar gaat de staffelkorting overheen. Alle bedragen
 * zijn ex btw; de sectie zegt dat er onder het totaal bij.
 *
 * Een optie kan een EIGEN staffel hebben (data-rg-staffel, bijvoorbeeld "25:15, 100:12").
 * Dat is iets anders dan de staffelkorting van stap vier. De korting is een percentage
 * over het hele pakket; deze staffel is de meerprijs van die ene optie, die zakt omdat
 * onze eigen kostprijs zakt. Bedrukking is het geval waarvoor dit bestaat: de film- en
 * screenkosten zijn eenmalig, dus bij 500 kisten kost het logo ons een kwart van wat het
 * bij 25 kost. Dat hoort de klant te zien, want het is precies het argument om meer af
 * te nemen. De twee stapelen: eerst de optieprijs bij dat aantal, dan de korting daarover.
 */
(function () {
  'use strict';

  var BEWAARSLEUTEL = 'rg-kanaal';

  /* Waar de bezoeker vandaan kwam.
   *
   * De eerste keer dat iemand deze pagina opent staan de utm-parameters nog in de
   * link. Klikt hij daarna door naar een fles en komt hij terug om het formulier in
   * te vullen, dan zijn ze weg en is de verwijzer onze eigen site. Zonder onthouden
   * zou zo'n aanvraag als "intern" binnenkomen en was de campagne die hem opleverde
   * onvindbaar. Vandaar dat de eerste meting in sessionStorage blijft staan.
   *
   * Beperking: dit script draait alleen op deze pagina. Wie op de homepage binnenkomt
   * met een utm-link en daarna hierheen navigeert, komt binnen als verwijzer van de
   * eigen site. Voor advertenties is dat geen probleem, want die linken rechtstreeks
   * naar deze pagina. Landt er ooit campagneverkeer ergens anders, dan hoort dit in
   * het thema en niet in deze sectie.
   */
  function bepaalKanaal() {
    var bewaard = null;
    try {
      bewaard = window.sessionStorage.getItem(BEWAARSLEUTEL);
    } catch (e) {
      bewaard = null;
    }

    var nu = '';
    try {
      var p = new URLSearchParams(window.location.search);
      var delen = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content']
        .map(function (naam) {
          var v = p.get(naam);
          return v ? naam.replace('utm_', '') + '=' + v : null;
        })
        .filter(Boolean);

      if (!delen.length) {
        var verwijzer = document.referrer || '';
        if (verwijzer) {
          var host = new URL(verwijzer).hostname.replace(/^www\./, '');
          if (host !== window.location.hostname.replace(/^www\./, '')) {
            delen.push('verwijzer=' + host);
          }
        } else if (!bewaard) {
          delen.push('direct');
        }
      }
      nu = delen.join(' · ').slice(0, 300);
    } catch (e) {
      nu = '';
    }

    /* Een verse herkomst wint van een bewaarde, want die is recenter. Is er geen
       verse, dan houden we vast wat we bij binnenkomst hebben gezien. */
    if (nu) {
      try {
        window.sessionStorage.setItem(BEWAARSLEUTEL, nu);
      } catch (e) {
        /* privémodus, dan alleen deze paginalading */
      }
      return nu;
    }
    return bewaard || 'intern';
  }

  function start(wortel) {
    if (wortel.dataset.rgKlaar === 'ja') return;
    wortel.dataset.rgKlaar = 'ja';

    var tekstTag = wortel.querySelector('script[data-rg-tekst]');
    var t = {};
    try {
      t = JSON.parse(tekstTag ? tekstTag.textContent : '{}');
    } catch (e) {
      t = {};
    }

    var staffel = (t.staffel || [])
      .filter(function (regel) {
        return Number(regel.vanaf) > 0 && Number(regel.procent) > 0;
      })
      .sort(function (a, b) {
        return Number(a.vanaf) - Number(b.vanaf);
      });

    var invoerAantal = wortel.querySelector('[data-rg-aantal]');
    var schuif = wortel.querySelector('[data-rg-schuif]');
    var regelLijst = wortel.querySelector('[data-rg-regels]');
    var uitPerStuk = wortel.querySelector('[data-rg-perstuk]');
    var uitTotaal = wortel.querySelector('[data-rg-totaal]');
    var overzicht = wortel.querySelector('[data-rg-overzicht]');
    var veldSamenvatting = wortel.querySelector('[data-rg-samenvatting]');
    var veldAantal = wortel.querySelector('[data-rg-aantalveld]');
    var veldPrijs = wortel.querySelector('[data-rg-prijsveld]');
    var keuzes = Array.prototype.slice.call(wortel.querySelectorAll('[data-rg-keuze]'));

    var taal = t.taal || 'nl';
    var munt = t.munt || '';

    function bedrag(waarde) {
      var afgerond = Math.round(waarde * 100) / 100;
      var heel = Math.abs(afgerond % 1) < 0.005;
      return (
        munt +
        afgerond.toLocaleString(taal, {
          minimumFractionDigits: heel ? 0 : 2,
          maximumFractionDigits: 2
        })
      );
    }

    function leesAantal() {
      var n = parseInt(invoerAantal && invoerAantal.value, 10);
      if (!n || n < 1) n = 1;
      var max = parseInt(invoerAantal && invoerAantal.max, 10) || 1000;
      if (n > max) n = max;
      return n;
    }

    /* De eigen staffel van een optie: "25:15, 100:12" wordt [{vanaf:25,prijs:15}, ...].
     * Onleesbare treden vallen weg in plaats van de rekenaar te laten struikelen: dit
     * veld wordt met de hand in de thema-editor gevuld en een typefout mag nooit de
     * hele pagina op nul zetten. */
    function leesOptieStaffel(invoer) {
      var ruw = (invoer.dataset.rgStaffel || '').trim();
      if (!ruw) return [];
      return ruw
        .split(',')
        .map(function (deel) {
          var s = deel.split(':');
          return { vanaf: parseInt(s[0], 10), prijs: parseFloat(s[1]) };
        })
        .filter(function (x) {
          return x.vanaf > 0 && isFinite(x.prijs);
        })
        .sort(function (a, b) {
          return a.vanaf - b.vanaf;
        });
    }

    /* Wat deze optie kost bij dit aantal. Zonder eigen staffel is dat gewoon de
     * vaste meerprijs. */
    function optiePrijs(invoer, aantal) {
      var basis = parseFloat(invoer.dataset.rgPrijs) || 0;
      var treden = leesOptieStaffel(invoer);
      for (var i = 0; i < treden.length; i++) {
        if (aantal >= treden[i].vanaf) basis = treden[i].prijs;
      }
      return basis;
    }

    /* Eenmalige kosten per order (data-rg-eenmalig): de voorbereiding van een gravure
     * of de instelkosten van een drukker. Die horen niet in de prijs per pakket, want
     * dan lijkt één kist met logo een vermogen te kosten en honderd kisten te goedkoop,
     * en ze horen niet onder de staffelkorting, want de leverancier geeft ons die
     * korting ook niet. Ze komen één keer bij het totaal. */
    function optieEenmalig(invoer) {
      return parseFloat(invoer.dataset.rgEenmalig) || 0;
    }

    /* De hoogste trede die het aantal haalt wint. */
    function zoekStaffel(aantal) {
      var gevonden = null;
      for (var i = 0; i < staffel.length; i++) {
        if (aantal >= Number(staffel[i].vanaf)) gevonden = staffel[i];
      }
      return gevonden;
    }

    function gekozen() {
      return keuzes.filter(function (invoer) {
        return invoer.checked;
      });
    }

    function tekenKaartStaat() {
      keuzes.forEach(function (invoer) {
        var kaart = invoer.closest('.rg-optie');
        if (kaart) kaart.classList.toggle('is-aan', invoer.checked);
      });
    }

    function werkBij() {
      var aan = gekozen();
      var aantal = leesAantal();

      /* Een verpakking kan meer dan één fles bevatten (data-rg-flessen, bijvoorbeeld de
       * kist met drie vakken). De champagneprijs telt dan zo vaak mee; de verpakking
       * en de extra's blijven één keer. Zonder dit rekende "drie cuvées in een kist"
       * één fles plus een kist, en dat klopt met geen enkele offerte. */
      var flessen = aan.reduce(function (n, invoer) {
        if (invoer.dataset.rgKeuze !== 'verpakking') return n;
        var f = parseInt(invoer.dataset.rgFlessen, 10);
        return f > 1 ? f : n;
      }, 1);
      function factor(invoer) {
        return invoer.dataset.rgKeuze === 'champagne' ? flessen : 1;
      }
      function regelTekst(invoer, n) {
        var p = optiePrijs(invoer, n);
        if (p <= 0) return t.gratis || '';
        return factor(invoer) > 1 ? factor(invoer) + ' × ' + bedrag(p) : bedrag(p);
      }

      var perStuk = aan.reduce(function (som, invoer) {
        return som + optiePrijs(invoer, aantal) * factor(invoer);
      }, 0);

      /* De prijs die BIJ de optie staat moet meelopen met het aantal, anders leest de
       * kaart "+ 18" terwijl de samenvatting rechts 12 rekent. Sinds 2 oktober 2026
       * worden alle labels bijgewerkt en niet alleen die met een eigen staffel: dit
       * stuk kent nu zelf het woord voor gratis en voor een vanafprijs, en het zet
       * een bedrag met centen in de notatie van de taal waarin de pagina staat. */
      keuzes.forEach(function (invoer) {
        var kaart = invoer.closest('.rg-optie');
        var label = kaart && kaart.querySelector('[data-rg-prijslabel]');
        if (!label) return;
        var p = optiePrijs(invoer, aantal);
        if (p <= 0) {
          label.textContent = t.gratis || '';
        } else if (invoer.getAttribute('data-rg-vanaf')) {
          /* Een vanafprijs krijgt geen plus ervoor: "vanaf EUR 12" en niet "+ EUR 12". */
          label.textContent = ((t.vanaf || '') + ' ' + bedrag(p)).trim();
        } else {
          label.textContent = '+ ' + bedrag(p);
        }
      });

      var bruto = perStuk * aantal;
      var trede = zoekStaffel(aantal);
      var kortingBedrag = trede ? (bruto * Number(trede.procent)) / 100 : 0;
      var netto = bruto - kortingBedrag;

      /* De klem: een pakket méér mag het totaal nooit verlagen.
       *
       * Zonder klem daalde het totaal bij 49 naar 50 pakketten (1.352,40 naar
       * 1.350,00), omdat de korting over het hele pakket gaat en de trede bij 50
       * begint; met een optie met eigen staffel gebeurde hetzelfde bij 24 naar 25 en
       * 99 naar 100. Geen rekenfout, maar precies wat een inkoper die narekent ziet.
       * Daarom: op elke trede (korting én optiestaffel) is het totaal minstens wat
       * het één pakket onder die trede was, en de korting wordt daarop teruggerekend. */
      function nettoBij(n) {
        var per = aan.reduce(function (som, invoer) {
          return som + optiePrijs(invoer, n) * factor(invoer);
        }, 0);
        var b = per * n;
        var tr = zoekStaffel(n);
        return b - (tr ? (b * Number(tr.procent)) / 100 : 0);
      }
      var grenzen = staffel.map(function (regel) {
        return Number(regel.vanaf);
      });
      aan.forEach(function (invoer) {
        leesOptieStaffel(invoer).forEach(function (tr) {
          grenzen.push(tr.vanaf);
        });
      });
      grenzen.forEach(function (grens) {
        if (grens > 1 && grens <= aantal) {
          var plafond = nettoBij(grens - 1);
          if (netto < plafond) netto = plafond;
        }
      });
      kortingBedrag = bruto - netto;

      var eenmalig = aan.reduce(function (som, invoer) {
        return som + optieEenmalig(invoer);
      }, 0);
      var totaal = netto + eenmalig;

      /* het overzicht rechts */
      if (regelLijst) {
        regelLijst.textContent = '';
        aan.forEach(function (invoer) {
          regelLijst.appendChild(maakRegel(invoer.value, regelTekst(invoer, aantal)));
        });
        if (aantal > 0) {
          regelLijst.appendChild(
            maakRegel(t.aantalLabel || '', aantal + (t.stuks ? ' ' + t.stuks : ''))
          );
        }
        if (trede) {
          /* Het BEDRAG erbij, niet alleen het percentage. Zonder het bedrag stond er
             "Per pakket 30", "Aantal 25", "-8%" en "Totaal 690", en dan moet de lezer
             zelf uitrekenen waar die 690 vandaan komt. Een inkoper die narekent en het
             niet ziet kloppen, vertrouwt de rest van de pagina ook niet meer.

             Het percentage is het EFFECTIEVE percentage, niet dat van de trede. Op de
             trede zelf houdt de klem hieronder het totaal vast op dat van één pakket
             minder; de korting is daar dus net iets kleiner dan de trede belooft (bij
             50 pakketten 9,8 in plaats van 10 procent). Zou er dan "-10%" staan naast
             een bedrag dat 9,8 procent is, dan klopt de kaart niet meer met zichzelf,
             en dat is precies waar dezelfde narekenende inkoper op afknapt. */
          var effectief = bruto > 0 ? (kortingBedrag / bruto) * 100 : 0;
          var procentTekst = (Math.round(effectief * 10) / 10)
            .toLocaleString(taal, { maximumFractionDigits: 1 });
          var kortingRegel = maakRegel(
            (t.kortingLabel || '') + (trede.label ? ' · ' + trede.label : ''),
            '-' + procentTekst + '%  ·  -' + bedrag(kortingBedrag)
          );
          kortingRegel.className = 'is-korting';
          regelLijst.appendChild(kortingRegel);
        }
        if (eenmalig > 0) {
          regelLijst.appendChild(maakRegel(t.eenmaligLabel || '', bedrag(eenmalig)));
        }
      }

      /* "Per pakket" moet de prijs zijn die de klant echt per pakket betaalt, dus NA
       * de staffelkorting. Stond hier eerder de brutoprijs, dan sprak de kaart zichzelf
       * tegen: bij 25 pakketten van 30 euro las je "Per pakket 30" en "Totaal 690",
       * terwijl 690 gedeeld door 25 op 27,60 uitkomt. Een inkoper die narekent ziet dat
       * meteen, en dan klopt er iets niet aan een pagina die om vertrouwen vraagt. */
      var nettoPerStuk = aantal > 0 ? netto / aantal : perStuk;
      if (uitPerStuk) uitPerStuk.textContent = bedrag(nettoPerStuk);
      if (uitTotaal) uitTotaal.textContent = bedrag(totaal);

      /* de samenvatting die met het formulier meegaat */
      var regels = aan.map(function (invoer) {
        var groep = invoer.dataset.rgGroep || '';
        return (groep ? groep + ': ' : '') + invoer.value + ' (' + regelTekst(invoer, aantal) + ')';
      });
      regels.push((t.aantalLabel || '') + ': ' + aantal);
      regels.push((t.perStuk || '') + ': ' + bedrag(nettoPerStuk));
      if (trede) {
        regels.push(
          (t.kortingLabel || '') +
            ': ' +
            (Math.round((bruto > 0 ? (kortingBedrag / bruto) * 100 : 0) * 10) / 10)
              .toLocaleString(taal, { maximumFractionDigits: 1 }) +
            '%' +
            (trede.label ? ' (' + trede.label + ')' : '')
        );
      }
      if (eenmalig > 0) {
        regels.push((t.eenmaligLabel || '') + ': ' + bedrag(eenmalig));
      }
      regels.push((t.totaal || '') + ': ' + bedrag(totaal));

      /* Twee vormen van dezelfde regels, met opzet.
         Op het scherm mogen ze onder elkaar staan, want daar is ruimte en het leest
         als een lijstje. In de mail niet: Shopify zet een eigen contact-veld neer als
         één naam-waardepaar, en een waarde met regeleindes kan daar tot één brij
         worden samengeplakt. Op één regel met een liggend streepje ertussen is hij
         in beide gevallen leesbaar. */
      var samenvatting = regels.join('\n');

      /* Alleen meesturen wat de bezoeker ZELF heeft samengesteld.
       *
       * Stap 1 en 2 staan voorgevinkt (forloop.first in de sectie), zodat de rekenaar
       * meteen iets laat zien in plaats van een lege kaart. Dat is goed voor het
       * begrip, maar het betekende ook dat iemand die rechtstreeks naar het formulier
       * scrolt een offerte meestuurde die hij nooit koos: "Laat ons kiezen,
       * geschenkdoos, 25 pakketten, 690 euro". Dan belt Jim over een pakket dat de
       * aanvrager niet kent, en dat kost precies het vertrouwen waar deze pagina om
       * vraagt.
       *
       * De vlag gaat aan bij de eerste echte handeling; pas dan vullen de verborgen
       * velden zich. Zolang hij uit staat leest de aanvraag als wat hij is: een vraag
       * zonder samenstelling. */
      var geraakt = wortel.dataset.rgGeraakt === 'ja';

      if (veldSamenvatting) veldSamenvatting.value = geraakt ? regels.join('  |  ') : '';
      if (veldAantal) veldAantal.value = geraakt ? String(aantal) : '';
      if (veldPrijs) veldPrijs.value = geraakt ? (Math.round(totaal * 100) / 100).toFixed(2) : '';

      if (overzicht) {
        overzicht.textContent = geraakt && aan.length
          ? (t.overzichtKop ? t.overzichtKop + '\n' : '') + samenvatting
          : t.nogNiets || '';
      }

      tekenKaartStaat();
    }

    function maakRegel(links, rechts) {
      var li = document.createElement('li');
      var a = document.createElement('span');
      var b = document.createElement('span');
      a.textContent = links;
      b.textContent = rechts;
      li.appendChild(a);
      li.appendChild(b);
      return li;
    }

    /* het cijfervak en de schuif houden elkaar bij */
    function zetAantal(waarde) {
      if (invoerAantal) invoerAantal.value = waarde;
      if (schuif) {
        var max = parseInt(schuif.max, 10) || 250;
        schuif.value = Math.min(waarde, max);
      }
      werkBij();
    }

    keuzes.forEach(function (invoer) {
      invoer.addEventListener('change', function () {
        wortel.dataset.rgGeraakt = 'ja';
        werkBij();
      });
    });
    if (invoerAantal) {
      invoerAantal.addEventListener('input', function () {
        wortel.dataset.rgGeraakt = 'ja';
        if (schuif) {
          var max = parseInt(schuif.max, 10) || 250;
          schuif.value = Math.min(leesAantal(), max);
        }
        werkBij();
      });
      invoerAantal.addEventListener('blur', function () {
        zetAantal(leesAantal());
      });
    }
    if (schuif) {
      schuif.addEventListener('input', function () {
        zetAantal(parseInt(schuif.value, 10) || 1);
      });
    }
    wortel.querySelectorAll('[data-rg-snel]').forEach(function (knop) {
      knop.addEventListener('click', function () {
        zetAantal(parseInt(knop.dataset.rgSnel, 10) || 1);
      });
    });

    /* Waar de aanvrager vandaan kwam, in het verborgen kanaalveld.
       Een relatiegeschenk-order loopt via mail en telefoon, niet via de kassa, dus
       zonder dit is geen enkele campagne te beoordelen. De utm-parameters uit de
       link gaan voor; ontbreken die, dan de verwijzende site. Alleen herkomst. */
    var veldKanaal = wortel.querySelector('[data-rg-kanaal]');
    if (veldKanaal) {
      veldKanaal.value = bepaalKanaal();
    }

    /* Vloeiend naar het doel in plaats van de harde sprong die een ankerlink maakt.
       Drie knoppen doen dit: van de hero naar de rekenaar, van de hero naar het
       formulier, en van de somkaart naar het formulier. Eén afhandelaar op de wortel
       vangt ze alle drie, ook als er later een knop bij komt.

       De offset is er omdat de site-header sticky is en bij omhoog scrollen terugkomt.
       Landt het doel exact bovenaan, dan staat het kopje er half achter. De hoogte
       wordt op het klikmoment gemeten en niet vastgezet, want hij verschilt per
       schermbreedte en met de aankondigingsbalk erboven. */
    wortel.addEventListener('click', function (e) {
      var link = e.target && e.target.closest ? e.target.closest('a[href^="#"]') : null;
      if (!link || !wortel.contains(link)) return;

      var naam = link.getAttribute('href').slice(1);
      if (!naam) return;
      var doel = document.getElementById(naam);
      if (!doel) return;

      e.preventDefault();

      var kop = document.querySelector('.section-header');
      var kophoogte = kop ? kop.offsetHeight || 0 : 0;
      /* Een uitgeklapt mobiel menu maakt de header schermvullend; dan telt hij niet. */
      if (kophoogte > 200) kophoogte = 0;

      var stil = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var top = doel.getBoundingClientRect().top + window.pageYOffset - kophoogte - 16;

      window.scrollTo({
        top: top > 0 ? top : 0,
        behavior: stil ? 'auto' : 'smooth'
      });

      /* De hash hoort wel in de adresbalk te blijven staan, anders is een gedeelde
         link naar de rekenaar niets meer waard. pushState zet hem er zonder te springen. */
      if (window.history && window.history.pushState) {
        window.history.pushState(null, '', '#' + naam);
      }
    });

    /* Wie op "vraag de offerte aan" klikt, wil daarna meteen typen. */
    var naarOfferte = wortel.querySelector('[data-rg-naaroffer]');
    if (naarOfferte) {
      naarOfferte.addEventListener('click', function () {
        var eersteVeld = wortel.querySelector('.rg-form input[type="text"]');
        if (eersteVeld) {
          window.setTimeout(function () {
            eersteVeld.focus({ preventScroll: true });
          }, 450);
        }
      });
    }

    werkBij();
  }

  function startAlles() {
    document.querySelectorAll('[data-rg]').forEach(start);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startAlles);
  } else {
    startAlles();
  }

  /* De thema-editor hangt de sectie opnieuw in de pagina bij elke wijziging. */
  document.addEventListener('shopify:section:load', function (e) {
    var wortel = e.target.querySelector('[data-rg]');
    if (wortel) start(wortel);
  });
})();
